import { Injector } from "@angular/core";
import { GridActionHandlerBase } from "../../../../../../components/common/grid-base/actions/grid-action-handler-base";
import { WorkspaceBase } from "../../../../../../components/common/workspace-base/workspace-base";
import { TranslateService } from "@ngx-translate/core";
import { AppLoadingIndicatorService } from "../../../../../../services/app-loading-indicator.service";
import { take } from "rxjs";

/**
 * Creates reports for all properties in a Valuation Event that don't have a report yet
 */
export class CreateReportsGridActionHandler extends GridActionHandlerBase {
  /**
   * TranslateService
   */
  private translate: TranslateService;
  /**
   * Constructor
   * @param injector Ihe Angular injector
   * @param workspace The workspace in which the action should be performed
   * @param appLoadingIndicator AppLoadingIndicatorService
   */
  constructor(injector: Injector, workspace: WorkspaceBase, private appLoadingIndicator: AppLoadingIndicatorService) {
    super(injector, workspace, 'portfolioCreateReports');
    this.translate = this.injector.get(TranslateService);
  }

  /**
  * Handles an event
  * @param _payload The (untyped) payload. Can also be a callback function
  */
  public handle(_payload: any): void {
    const selectedItem = this.workspace.grid.selectedItem;
    if (selectedItem) {
      const valuationProjectId = selectedItem.Oid;
      this.appLoadingIndicator.show();

      const url = this.appServiceHelper.getServiceEndpoint('pollux.projectValuation.api', `Reports/bulkCreate?valuationProjectId=${valuationProjectId}`);

      this.http.post(url, {}).pipe(take(1)).subscribe({
        next: (result: any) => {
          if (result.success) {
            const filter = this.workspace?.grid?.state?.filter;

            this.workspace.grid.applyFilter(filter, valuationProjectId).then(() => {
              this.eventBus.broadcastEvent('reportsDataSaved', selectedItem);

              if (result.reportCount == 0) {
                this.eventBus.broadcastEvent("openConfirmDialog", {
                  success: () => {
                    //Nothing
                  }
                }, 'errorMessageNoReportsCreated');
              }
              else if (result.reportCount == 1) {
                this.eventBus.broadcastEvent("openConfirmDialog", {
                  success: () => {
                    //Nothing
                  }
                }, 'errorMessageReportCreated');
              }
              else {
                alert(this.translate.instant('errorMessage.reportsCreated', { reportCount: result.reportCount }));
              }
            });
          }

          this.appLoadingIndicator.hide();
        },
        error: (_error) => {
          this.appLoadingIndicator.hide();
        }
      });
    }
    else {
      this.eventBus.broadcastEvent("openConfirmDialog", {
        success: () => {
          //Nothing
        }
      }, 'projectValuationNoPortfolio');
    }
  }
}
